// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"200":"dfa14177","453":"2357470a"}[chunkId] + ".chunk.js";
};